//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmLink from '~/components/atoms/MdmLink';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bx-chevron-right.svg';
export default {
  name: 'ArrowLink',
  components: {
    MdmLink
  },
  props: {
    url: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
};